<template>
  <div class="row mt-1" v-if="!sorted_bids.length">
    <div class="col bg-info border rounded">Awaiting bids...</div>
  </div>
  <ul v-else class="list-group mt-1" v-for="(b, index) in sorted_bids" :key="b">
    <li class="list-group-item bg-grad-yellow border rounded" v-if="!index">
      <div class="row d-flex align-items-center">
        <div class="col">
          <ul class="list-group">
            <li
              class="list-group-item padding1 bg-grad-yellow border-0 fw-bold"
              v-for="n in getTeamName(b.team_id).trim().split(/\s+/)"
              :key="n"
            >
              {{ n }}
            </li>
          </ul>
          <!-- {{ getTeamName(b.team_id) }} -->
        </div>
        <div class="col">
          <LogoLarge :path="getTeamPath(b.team_id)"></LogoLarge>
        </div>
        <div class="col fw-bold">{{ formatToIndianCurrency(b.amount) }}</div>
      </div>
    </li>
  </ul>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import LogoLarge from "../../bidder/logos/LogoLarge.vue";
const store = useStore();
const live_bids = ref([]);
const all_teams = ref([]);
onMounted(() => {
  setTimeout(() => {
    fetchBids();
    fetchTeams();
  }, 1000);
});
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
};
const fetchBids = async () => {
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")

    // Filters
    .eq("player_id", store.viewer_live_player_id);
  live_bids.value = bids;
  setupBidsListner();
};
const setupBidsListner = () => {
  const channels = supabase
    .channel("viewer-live-bids-t37-custom-all-channel")
    .on(
      "postgres_changes",
      { event: "*", schema: "public", table: "bids" },
      (payload) => {
        if (
          payload.eventType == "INSERT" &&
          payload.new.player_id == store.viewer_live_player_id
        ) {
          live_bids.value.push(payload.new);
        }
        if (payload.eventType == "DELETE") {
          const index = live_bids.value.findIndex(
            (item) => item.id === payload.old.id
          );
          if (index != -1) {
            live_bids.value.splice(index, 1);
          }
        }
        if (payload.eventType == "UPDATE") {
          const index = live_bids.value.findIndex(
            (item) => item.id === payload.old.id
          );
          if (index != -1) {
            live_bids.value.splice(index, 1);
            live_bids.value.push(payload.new);
          }
        }
      }
    )
    .subscribe();
};
const sorted_bids = computed(() => {
  var arr = [];
  live_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  //sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  sorted_arr = arr.sort((a, b) => b.amount - a.amount);

  return sorted_arr;
});
const getTeamName = (id) => {
  var name = "";
  all_teams.value.forEach((t) => {
    if (t.id == id) {
      name = t.name;
    }
  });
  return name;
};
const getTeamPath = (id) => {
  var path = "";
  all_teams.value.forEach((t) => {
    if (t.id == id) {
      path = t.icon;
    }
  });
  return path;
};
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
</script>
<style scoped>
.padding1 {
  padding: 1px;
}
</style>
